<template>
  <div class="monthlyChannel">
    <!-- <yearAndMonthSelect></yearAndMonthSelect> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>招聘渠道分类统计</el-breadcrumb-item>
          <el-breadcrumb-item>月报</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="monthlyChannelTable">
        <el-table :data="tableData" style="width: 99%" stripe @cell-click="handdle" v-loading="listLoading" element-loading-text="报表实时生成中"
              element-loading-spinner="el-icon-loading">
          <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
          <el-table-column align="center" label="序号" width="50px">
            <template slot-scope="scope">
              <span>{{(listQuery.currpage - 1) * listQuery.perpage + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrSrvCent"></el-table-column>
          <el-table-column align="center" label="市内">
            <template slot-scope="scope">
               <div class="green">{{scope.row.Incityempuser}}</div>
               <div class="rate">{{scope.row.IncityempuserRate&&scope.row.IncityempuserRate!='NaN'?(scope.row.IncityempuserRate*100).toFixed(2)+'%':0}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="市外">
            <template slot-scope="scope">
              <div class="green">{{scope.row.Outcityempuser}}</div>
              <div class="rate">{{scope.row.OutcityempuserRate&&scope.row.OutcityempuserRate!='NaN'?(scope.row.OutcityempuserRate*100).toFixed(2)+'%':0}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="其他">
            <template slot-scope="scope">
              <div class="green">{{scope.row.Otherempuser}}</div>
              <div class="rate">{{scope.row.OtherempuserRate&&scope.row.OtherempuserRate!='NaN'?(scope.row.OtherempuserRate*100).toFixed(2)+'%':0}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合计">
            <template slot-scope="scope">
              <div>{{scope.row.Allempuser}}</div>
              <div>{{scope.row.AllempuserRate}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount>0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10000"
            layout="total,prev, pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
      <!-- <router-link to='/monthlyReport'>转跳哦</router-link> -->
    </div>
    <el-drawer :visible.sync="drawer1" :with-header="false" :modal="false" size="68%">
      <div class="titleAndButton">
        <div class="monthlyTitle">
         招聘渠道分类统计 |  {{strsrvcent1}} |  {{toChildrenData.strdate}} 
        </div>
        <div>
          <el-input size="small" v-model="serDtlQuery.strobjname" placeholder="请输入项目名称" @keyup.enter.native="onSearch" style="width:200px;margin-right:10px"></el-input>
          <el-button size="small" style="margin-right:10px;vertical-align: bottom;font-size:13px" :loading="btnLoading1" @click="exportHandle1">导出</el-button>
          <button class="clear" @click="drawer1=false" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyChannelTable">
        <el-table :data="tableData3" v-loading="drawer1Loading" style="width: 99%" stripe  @cell-click="handdle3">
          <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
          <el-table-column align="center" label="序号" width="100px">
            <template slot-scope="{$index}">
              <span>{{Number($index)+1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName"></el-table-column>
          <el-table-column align="center" label="市内">
            <template slot-scope="scope">
               <div class="green">{{scope.row.Incityempuser}}</div>
               <div class="rate">{{(scope.row.IncityempuserRate*100).toFixed(2)+'%'}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="市外" prop="outsideCity">
            <template slot-scope="scope">
              <div class="green">{{scope.row.Outcityempuser}}</div>
              <div class="rate">{{(scope.row.OutcityempuserRate*100).toFixed(2)+'%'}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="其他" prop="otherChannel">
            <template slot-scope="scope">
              <div class="green">{{scope.row.Otherempuser}}</div>
              <div class="rate">{{(scope.row.OtherempuserRate*100).toFixed(2)+'%'}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合计" prop="total">
            <template slot-scope="scope">
              <div>{{scope.row.Allempuser}}</div>
              <div>{{(scope.row.AllempuserRate*100).toFixed(2)+'%'}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount3>0">
          <el-pagination
          @size-change="handleSize3"
            @current-change="handleCurrentChange3"
            :current-page.sync="serDtlQuery.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total,sizes,prev,pager,next,jumper"
            :total="totalcount3"
          ></el-pagination>
        </div>
      </div>
      </div>
    </el-drawer>

    <el-drawer :visible.sync="drawer2" :with-header="false" :modal="false" size="1180px">
      <div class="titleAndButton">
        <div class="monthlyTitle">
         {{strsrvcent1}} | {{cityTxt}}招聘名单 {{toChildrenData.strdate}}
        </div>
        <div>
          <el-input size="small" v-model="cityDtlQuery.strobjname" placeholder="请输入项目名称" @keyup.enter.native="onSearch2" style="width:200px;margin-right:10px"></el-input>
          <el-button size="small" style="margin-right:10px;vertical-align: bottom;font-size:13px" :loading="btnLoading2" @click="exportHandle2">导出</el-button>
          <button class="clear" @click="drawer2=false" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyReportTable">
        <el-table :data="tableData5" v-loading="drawer2Loading" style="width: 99%" stripe @cell-click="handdle2">
          <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
          <el-table-column align="center" label="序号" width="100px">
              <template slot-scope="{$index}">
              <span>{{Number($index)+1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName" ></el-table-column>
          <el-table-column align="center" label="劳动合同签署公司全称" prop="StrBlCmp"></el-table-column>
          <el-table-column align="center" label="员工姓名" prop="StrEmpName"></el-table-column>
          <el-table-column align="center" label="身份证号码" prop="StrIdCard"></el-table-column>
          <el-table-column align="center" label="用工之日">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtEntryBdate)?'':scope.row.DtEntryBdate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="在/离职状态" prop="StrWorkState"></el-table-column>
          <el-table-column align="center" label="离职日期">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtDepartureDate)?'':scope.row.DtDepartureDate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="实际离职日期">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtRealDepartureDate)?'':scope.row.DtRealDepartureDate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="招聘渠道">
            <template slot-scope="scope">
              <span v-if="scope.row.StrInCity">{{scope.row.StrInCity}}</span>
              <span v-if="scope.row.StrOutsideCity">{{scope.row.StrInCity ? '/' +  scope.row.StrOutsideCity : scope.row.StrOutsideCity}}</span>
              <span v-if="scope.row.StrOther">{{(scope.row.StrInCity|| scope.row.StrOutsideCity) ? '/' + scope.row.StrOther :scope.row.StrOther}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount5>0">
          <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page.sync="cityDtlQuery.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total,sizes,prev,pager,next,jumper"
            :total="totalcount5"
          ></el-pagination>
        </div>
      </div>
      </div>
    </el-drawer>

    <el-drawer :visible.sync="drawer3" :with-header="false" :modal="false" size="66%">
      <div class="titleAndButton">
        <div class="monthlyTitle">
         市内招聘名单  |  {{strsrvcent1}} | {{toChildrenData.strdate}} |  {{strobjname2}}
        </div>
        <div>
          <el-button size="small" style="margin-right:10px;vertical-align: bottom;font-size:13px" :loading="btnLoading3" @click="exportHandle3">导出</el-button>
          <button class="clear" @click="drawer3=false" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyReportTable">
        <el-table :data="tableData6" v-loading="drawer3Loading" style="width: 99%" stripe >
          <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
          <el-table-column align="center" label="序号" width="100px">
            <template slot-scope="{$index}">
              <span>{{Number($index)+1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="员工姓名" prop="StrEmpName"></el-table-column>
          <el-table-column align="center" label="身份证号码" prop="StrIdCard"></el-table-column>
          <el-table-column align="center" label="用工之日">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtEntryBdate)?'':scope.row.DtEntryBdate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="离职日期">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtDepartureDate)?'':scope.row.DtDepartureDate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="招聘渠道">
            <template slot-scope="scope">
              <span v-if="scope.row.StrInCity">{{scope.row.StrInCity}}</span>
              <span v-if="scope.row.StrOutsideCity">{{scope.row.StrInCity ? '/' +  scope.row.StrOutsideCity : scope.row.StrOutsideCity}}</span>
              <span v-if="scope.row.StrOther">{{(scope.row.StrInCity|| scope.row.StrOutsideCity) ? '/' + scope.row.StrOther :scope.row.StrOther}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount5>0">
          <el-pagination
          @size-change="handleSize6"
            @current-change="handleCurrentChange6"
            :current-page.sync="serDtlQuery.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total,sizes,prev,pager,next,jumper"
            :total="totalcount6"
          ></el-pagination>
        </div>
      </div>
      </div>
    </el-drawer>

    <el-drawer :visible.sync="drawer4" :with-header="false" :modal="false" size="67%">
      <div class="titleAndButton">
        <div class="monthlyTitle">
         招聘渠道分类统计  |  {{strsrvcent1}} | {{toChildrenData.strdate}} |  {{strobjname2}} |  分渠道招聘名单
        </div>
        <div>
          <el-button size="small" style="margin-right:10px;vertical-align: bottom;font-size:13px" :loading="btnLoading4" @click="exportHandle4">导出</el-button>
          <button class="clear" @click="drawer4=false" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyReportTable">
        <el-table :data="tableData7" v-loading="drawer4Loading" style="width: 99%" stripe >
          <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
          <el-table-column align="center" label="序号" width="100px">
            <template slot-scope="{$index}">
              <span>{{Number($index)+1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="员工姓名" prop="StrEmpName"></el-table-column>
          <el-table-column align="center" label="身份证号码" prop="StrIdCard"></el-table-column>
          <el-table-column align="center" label="用工之日">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtEntryBdate)?'':scope.row.DtEntryBdate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="离职日期">
             <template slot-scope="scope">
              <span>{{isNull(scope.row.DtDepartureDate)?'':scope.row.DtDepartureDate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="市内">
            <template slot-scope="scope">
              <span>{{scope.row.StrOther+'/'+scope.row.StrOutsideCity}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="市外">
            <template slot-scope="scope">
              <span>{{scope.row.StrOther+'/'+scope.row.StrOutsideCity}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="其他" prop="otherChannel">
            <template slot-scope="scope">
              <span>{{scope.row.StrOther+'/'+scope.row.StrOutsideCity}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount7">
          <el-pagination
          @size-change="handleSize7"
            @current-change="handleCurrentChange7"
            :current-page.sync="cityDtlQuery.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total,sizes,prev,pager,next,jumper"
            :total="totalcount7"
          ></el-pagination>
        </div>
      </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import xz from "../../common";
import { parseTime } from '../../utils' //格式化时间格式
// import yearAndMonthSelect from "../../employee/assembly/yearAndMonthSelect";
export default {
  props: {
    toChildrenData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
   components: {
    // yearAndMonthSelect
    parseTime
  },
  data () {
    return {
      listLoading:false,
      drawer1Loading:false,
      drawer2Loading:false,
      drawer3Loading:false,
      drawer4Loading:false,
      drawer1:false,
      drawer2:false,
      drawer3:false,
      drawer4:false,
      btnLoading1:false,
      btnLoading2:false,
      btnLoading3:false,
      btnLoading4:false,
      currentPage:1,
      currentPage2:1,
      currentPage3:1,
      currentPage5:1,
      currentPage6:1,
      currentPage7:1,
      totalcount:0,
      totalcount3:0,
      totalcount5:0,
      totalcount6:0,
      totalcount7:0,
      strsrvcent1:'',
      //项目名称
      strobjname2:'',
      listQuery: {
        perpage:10000,
        currpage:1,
        strdatetype:"mouth",
        strdate:"",
        strsrvcent:""
      },
      serDtlQuery: {
        perpage:10,
        currpage:1,
        strobjname:""
      },
      //市内市外参数
      cityDtlQuery:{
        perpage:10,
        currpage:1,
        strtype:"",  //all  市内 市外 其他
        strobjname:""
      },
      strsrvcent2:'',
      cityTxt:'',
      tableData:[],
      tableData3:[],
      tableData5:[],
      tableData6:[],
      tableData7:[]
    }
  },
  async created(){
    //父组件传的值
    this.getList(this.toChildrenData)
  },
  methods : {
    //表格
    async getList(query){
      this.listLoading = true
      this.tableData = []
      // console.log('getOpeRecord',query)
      xz.getUserCity(query).then(res=>{
        // console.log('getOpeRecord',res)
        if(res.msg && res.msg.length>0){
          this.totalcount = parseInt(res.totalcount);
          this.tableData = res.msg
          this.listLoading = false
        } else if(res=='404'){
          this.getList(query)
        }else{
          this.totalcount = 0
          this.tableData = []
          this.listLoading = false
        }
        this.sendMsg()
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    },
    //子组件传给父组件的值
    sendMsg(){
      //func: 是父组件指定的传数据绑定的函数，tableData:子组件给父组件传递的数据
      this.$emit('func',this.tableData)
    },
    //点击服务中心详情
    getDtlList(){
      this.drawer1Loading = true
      this.tableData3 = []
      // console.log('getUserBaseCitydetail',this.toChildrenData.strsrvcent,this.toChildrenData.strdatetype,this.toChildrenData.strdate)
      xz.getUserBaseCitydetail(this.strsrvcent1,this.toChildrenData.strdatetype,this.toChildrenData.strdate,this.serDtlQuery).then(res=>{
        // console.log('getUserBaseCitydetail',res)
        if(res.msg && res.msg.length>0){
          this.totalcount3 = parseInt(res.totalcount);
          this.tableData3 = res.msg
        }else{
          this.totalcount3 = 0
          this.tableData3 = []
        }
        this.drawer1Loading = false
      })
    },
    //点击市内市外详情
    async getCityList(){
      if(this.drawer4 == true){
        this.tableData7 = []
        this.drawer4Loading = true
      }else{
        this.tableData5 = []
        this.drawer2Loading = true
      }
      // console.log('aa',this.cityDtlQuery)
       xz.getBaseUserInCityList(this.strsrvcent2,this.toChildrenData.strdate,this.cityDtlQuery).then(res=>{
        // console.log('getCityList',res)
        if(res.msg.data && res.msg.data.length>0){
          if(this.drawer4 == true){
            this.totalcount7 = parseInt(res.msg.totalcount);
            this.tableData7 = res.msg.data
            this.drawer4Loading = false
          }else{
            this.totalcount5 = parseInt(res.msg.totalcount);
          this.tableData5 = res.msg.data
          this.drawer2Loading = false
          }
        }else{
          if(this.drawer4 == true){
            this.totalcount7 = 0
          this.tableData7 = []
          this.drawer4Loading = false
          }else{
            this.totalcount5 = 0
          this.tableData5 = []
          this.drawer1Loading = false
          }
        }
      })
    },
    //服务中心里点击项目名称的详情
    async getDtlItemList(){
      if(this.drawer1==true){
        this.drawer1Loading = true
        this.tableData3 = []
      }else{
        this.tableData6 = []
        this.drawer3Loading = true
      }
      // console.log('getUserBaseCitydetail',this.toChildrenData.strsrvcent,this.toChildrenData.strdatetype,this.toChildrenData.strdate)
      xz.getUserBaseCitydetail(this.strsrvcent1,this.toChildrenData.strdatetype,this.toChildrenData.strdate,this.serDtlQuery).then(res=>{
        // console.log('getUserBaseCitydetail',res)
        if(res.msg && res.msg.length>0){
          if(this.drawer1==true){
           this.totalcount3 = parseInt(res.totalcount);
          this.tableData3 = res.msg
          this.drawer1Loading = false
          }else{
             this.totalcount6 = parseInt(res.totalcount);
          this.tableData6 = res.msg
          this.drawer3Loading = false
          }
        }else{
          if(this.drawer1==true){
            this.totalcount3 = 0
            this.tableData3 = []
            this.drawer1Loading = false
          }else{
              this.totalcount6 = 0
            this.tableData6 = []
            this.drawer3Loading = false
          }
        }
      })
    },
    //服务中心详情搜索
    onSearch(){
      this.getDtlList()
    },
     //市内市外详情搜索
    onSearch2(){
      this.getCityList()
    },
    //导出1
    exportHandle1(){
      this.btnLoading1 = true;
      //reporttype ：员工统计 员工统计详情  渠道统计  渠道统计详情  渠道统计雇员
      // console.log("exportQuery", this.exportQuery);
      this.serDtlQuery.currpage = 1
      this.serDtlQuery.perpage = 100000
      xz.reportCurrDataTable('渠道统计详情',this.strsrvcent1,this.toChildrenData.strdatetype,this.toChildrenData.strdate,this.serDtlQuery).then(res => {
        // console.log("reportCurrDataTable", res);
        if(res.status == 'ok'){
          this.btnLoading1 = false;
          this.$router.push({ 
            path: '/employee-exportRecordList',
            query: {
              custname: res.msg,
              isReport:true
            }})
        }else{
           this.btnLoading1 = false;
           this.$message({
            message: "导出错误",
            type: "error"
          })
        }
      });
    },
    //导出2
    exportHandle2(){
      this.btnLoading2 = true;
      this.cityDtlQuery.currpage = 1
      this.cityDtlQuery.perpage = 100000
      //reporttype ：员工统计 员工统计详情  渠道统计  渠道统计详情  渠道统计雇员
      xz.reportCurrDataTable('渠道统计雇员',this.strsrvcent1,this.toChildrenData.strdatetype,this.toChildrenData.strdate,this.cityDtlQuery).then(res => {
        // console.log("reportCurrDataTable", res);
        if(res.status == 'ok'){
          this.btnLoading2 = false;
          this.$router.push({ 
            path: '/employee-exportRecordList',
            query: {
              custname: res.msg,
              isReport:true
            }})
        }else{
           this.btnLoading2 = false;
           this.$message({
            message: "导出错误",
            type: "error"
          })
        }
      });
    },
    //导出3
    exportHandle3(){},
    //导出4
    exportHandle4(){
      this.btnLoading4 = true;
      this.cityDtlQuery.currpage = 1
      this.cityDtlQuery.perpage = 100000
      //reporttype ：员工统计 员工统计详情  渠道统计  渠道统计详情  渠道统计雇员
      // console.log("exportQuery",this.strdatetype1,this.toChildrenData.strdate,this.cityDtlQuery);
      xz.reportCurrDataTable('渠道统计雇员',this.strsrvcent1,this.toChildrenData.strdatetype,this.toChildrenData.strdate,this.cityDtlQuery).then(res => {
        // console.log("reportCurrDataTable", res);
        if(res.status == 'ok'){
          this.btnLoading4 = false;
          this.$router.push({ 
            path: '/employee-exportRecordList',
            query: {
              custname: res.msg,
              isReport:true
            }})
        }else{
           this.btnLoading4 = false;
           this.$message({
            message: "导出错误",
            type: "error"
          })
        }
      });
    },
    //分页
    handleSize3(val){
      this.serDtlQuery.perpage = val
      this.serDtlQuery.currpage = 1
      this.getDtlList()
    },
    handleSizeChange2(val){
      this.cityDtlQuery.currpage = 1
      this.cityDtlQuery.perpage = val
      this.getCityList()
    },
     handleSize6(val){
      this.serDtlQuery.perpage = val
      this.serDtlQuery.currpage = 1
      this.getDtlList()
    },
    handleSize7(val){
      this.cityDtlQuery.perpage = val
      this.cityDtlQuery.currpage = 1
      this.getCityList()
    },
    handleClick(row) {
      console.log(row);
    },
    handleSizeChange(val) {
      this.page = val
      this.listQuery.currpage = val
      this.getList(this.toChildrenData)
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.listQuery.currpage = val
      this.currentPage = val
      this.getList(this.toChildrenData)
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange2(val) {
      this.cityDtlQuery.currpage = val
      this.cityDtlQuery.perpage = 10
      this.currentPage2 = val
      this.getCityList()
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange3(val) {
      this.serDtlQuery.currpage = val
      this.serDtlQuery.perpage = 10
       this.currentPage3 = val
      this.getDtlList()
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange6(val) {
      this.serDtlQuery.currpage = val
      this.serDtlQuery.perpage = 10
      this.currentPage6 = val
      this.getDtlItemList()
    },
    handleCurrentChange7(val) {
      this.cityDtlQuery.currpage = val
      this.cityDtlQuery.perpage = 10
      this.currentPage7 = val
      this.getCityList()
    },
    async handdle(row, event, column,cell){
      // console.log(row, event, column,cell)
      this.strsrvcent1 = row.StrSrvCent
      this.strsrvcent2 = row.StrSrvCent
      this.cityDtlQuery.currpage = 1
      this.serDtlQuery.perpage = 10
      this.serDtlQuery.currpage = 1
       if(event.label=='服务中心'){
         if(row.Incityempuser<=0&&row.Outcityempuser<=0&&row.Otherempuser<=0){
          this.drawer1 = false
         }else{
           this.drawer1 = true
           this.serDtlQuery.currpage = 1
          this.getDtlList()
         }
        console.log('row',row)
      } 
       if(event.label=='市内'){
        if(row.Incityempuser>0){
          this.drawer2 = true
          this.cityDtlQuery.strtype='市内'
          this.getCityList()
        }else{
          this.drawer2 = false
        }
        this.cityTxt = '市内'
      }else if(event.label=='市外'){
         this.cityDtlQuery.strtype='市外'
        if(row.Outcityempuser>0){
          this.drawer2 = true
           this.getCityList()
        }else{
          this.drawer2 = false
        }
        this.cityTxt = '市外'
      }else if(event.label=='其他'){
        this.cityDtlQuery.strtype='其他'
        if(row.Otherempuser>0){
          this.drawer2 = true
          this.getCityList()
        }else{
          this.drawer2 = false
        }
        this.cityTxt = '其他'
      }
    },
    async handdle2(row, event, column,cell){
      this.cityDtlQuery.currpage = 1
      this.serDtlQuery.currpage = 1
      if(event.label=='市内'){
        this.cityDtlQuery.strtype='市内'
        if(row.Incityempuser>0){
          this.drawer4 = true
          this.getCityList()
        }else{
          this.drawer4 = false
        }
        this.cityTxt = '市内'
      }else if(event.label=='市外'){
        this.cityDtlQuery.strtype='市外'
        if(row.Outcityempuser>0){
          this.drawer4 = true
           this.getCityList()
        }else{
          this.drawer4 = false
        }
        this.cityTxt = '市外'
      }else if(event.label=='其他'){
        this.cityDtlQuery.strtype='其他'
        if(row.Otherempuser>0){
          this.drawer4 = true
          this.getCityList()
        }else{
          this.drawer4 = false
        }
        this.cityTxt = '其他'
      }
    },
    async handdle3(row, event, column,cell){
      this.cityDtlQuery.currpage = 1
       this.serDtlQuery.currpage = 1
      console.log('dtl',row, event)
      this.strobjname2 = row.StrObjName
      // this.cityDtlQuery.strobjname = row.StrObjName
      if(event.label=='项目名称'){
        this.drawer4 = true
        this.getCityList()
      }
      if(event.label=='市内'){
         this.cityDtlQuery.strtype='市内'
        if(row.Incityempuser>0){
          this.drawer2 = true
          this.getCityList()
        }else{
          this.drawer2 = false
        }
        this.cityTxt = '市内'
      }else if(event.label=='市外'){
         this.cityDtlQuery.strtype='市外'
        if(row.Outcityempuser>0){
          this.drawer2 = true
           this.getCityList()
        }else{
          this.drawer2 = false
        }
        this.cityTxt = '市外'
      }else if(event.label=='其他'){
        this.cityDtlQuery.strtype='其他'
        if(row.Otherempuser>0){
          this.drawer2 = true
          this.getCityList()
        }else{
          this.drawer2 = false
        }
        this.cityTxt = '其他'
      }
    },
     //时间取值
    async getTimeSet () {
      const baseTime = this.listQuery.dateVal
      const dateMoments = new Date(baseTime)
      const monthFirstDates = dateMoments.getFullYear() + '-' + (dateMoments.getMonth() + 1) + '-01'
      // console.log('月第一天',monthFirstDates)
      let startTimes = dateMoments.toLocaleDateString().split('/')
      // console.log('开始时间',startTimes)
      const monthDates = new Date(Number(startTimes[0]), Number(startTimes[1]), 0).toLocaleDateString().split('/')
      // console.log('月时间',monthDates)
      if (this.dateType == 'month') {
        this.listQuery.startdate = monthFirstDates
        this.listQuery.enddate = monthDates.join('-')
        this.listQuery.date = [monthFirstDates, monthDates.join('-')]
      }
      // 处理日期超时
      if (new Date(this.listQuery.startdate).getTime() > new Date().getTime()) {
        this.listQuery.startdate = new Date().toLocaleDateString().split('/').join('-')
      }
      if (new Date(this.listQuery.enddate).getTime() > new Date().getTime()) {
        this.listQuery.enddate = new Date().toLocaleDateString().split('/').join('-')
      }
      // 格式化时间
      this.listQuery.startdate = parseTime(new Date(this.listQuery.startdate), '{y}-{m}-{d}')
      this.listQuery.enddate = parseTime(new Date(this.listQuery.enddate), '{y}-{m}-{d}')
      this.listQuery.date = [this.listQuery.startdate, this.listQuery.enddate]
      if(this.dateType == 'month'){
        this.listQuery.strdate = this.listQuery.date.join()
      }else{
        this.listQuery.strdate = this.listQuery.date.join()
      }
      console.log('时间strdate',this.listQuery.strdate)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   
</style>
<style>
.el-table--enable-row-hover .el-table__body tr:hover{
  cursor: pointer;
}
.monthlyChannelTable .el-table td{
  padding: 0;
}
.monthlyChannelTable  .el-table th{
  padding: 8px 0 ;
}
.monthlyReportTable .el-table td{
  padding: 8px 0;
}
.monthlyReportTable .el-table th{
  padding: 6px 0;
}
</style>